import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const YouthArise = () => {
  const { t } = useLanguage();
  const tags = t('youth.tags');
  return (
    <section id="youth" className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1563902341721-029085ad9347?w=1600)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/95 via-[#0f2440]/90 to-orange-900/80"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Text Content */}
          <div className="space-y-6" data-testid="youth-arise-content">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/20 border border-orange-400/30 rounded-full">
              <Sparkles className="w-4 h-4 text-orange-300" />
              <span className="text-sm font-medium text-orange-200">{t('youth.badge')}</span>
            </div>

            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight">
              YOUTH
              <span className="block text-orange-400">ARISE!</span>
            </h2>

            <p className="text-lg text-white/80 max-w-md leading-relaxed">
              {t('youth.subtitle')}
            </p>

            {/* Tags */}
            <div className="flex flex-wrap gap-3 pt-2">
              {(Array.isArray(tags) ? tags : ['Gemeinschaft', 'Glaube', 'Freundschaft', 'Jesus']).map((tag) => (
                <span 
                  key={tag} 
                  className="px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/15 rounded-full text-sm text-white/90 font-medium"
                >
                  {tag}
                </span>
              ))}
            </div>

            <button
              onClick={() => document.getElementById('events')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="youth-arise-cta"
              className="inline-flex items-center gap-3 px-8 py-4 bg-orange-500 text-white rounded-lg 
                         font-semibold hover:bg-orange-400 transition-all hover:scale-105 hover:shadow-2xl
                         hover:shadow-orange-500/25 mt-2 text-lg"
            >
              {t('youth.cta')}
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* Image */}
          <div className="relative hidden lg:block">
            <div className="absolute -inset-4 bg-gradient-to-br from-orange-400/20 to-sky-400/20 rounded-3xl blur-2xl"></div>
            <img
              src="https://images.unsplash.com/photo-1566135235200-616a028972c9?w=800"
              alt="Youth Arise - Jugendgruppe"
              className="relative rounded-3xl shadow-2xl w-full h-[450px] object-cover border-2 border-white/10"
              data-testid="youth-arise-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default YouthArise;
